<template>
  <div class="Main">
    <header class="head">
      <p>{{getHead($route)}}</p>
      <div @click="shows = true" class="menu">
        <img alt="" src="~@/assets/imgs/index-menu.png">
      </div>
    </header>
    <div class="content-app">
      <router-view/>
    </div>

    <van-popup
      :style="{ height: '30%' }"
      position="top"
      v-model="shows"
    >
      <div @click="shows = false" class="menu-popup">
        <div class="menu-top">
          <p>菜单选择</p>
        </div>
        <div class="menu-content">
          <div @click.stop="putRouter('index')">
            <div class="img-box">
              <img alt="" src="~@/assets/imgs/home.png">
            </div>
            <p>首页</p>
          </div>
          <div @click.stop="putRouter('day')">
            <div class="img-box">
              <img alt="" src="~@/assets/imgs/day.png">
            </div>
            <p>运营日报</p>
          </div>
          <div @click.stop="putRouter('monthly')">
            <div class="img-box">
              <img alt="" src="~@/assets/imgs/m.png">
            </div>
            <p>运营月报</p>
          </div>
          <div @click.stop="putRouter('logistics-day')">
            <div class="img-box">
              <img alt="" src="~@/assets/imgs/logistics.png">
            </div>
            <p>物流日报</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

  export default {
    name: 'Main',
    data() {
      return {
        shows: false
      }
    },
    created() {},
    methods: {
      putRouter(name) {
        this.$router.push({ name })
        this.shows = false
      }
    },
    components: {},
    computed: {
      getHead() {
        return route => {
          return route.meta.head || '淘通科技'
        }
      }
    },
    mounted() {},
    beforeDestroy() {},
    destroyed() {}
  }
</script>

<style lang="scss" scoped>
  .Main {
    padding-top: 10px;
    height: 100vh;
    overflow-x: auto;
    background: #242A40;
  }
</style>
